import { Table } from "antd";
import React, { useState } from "react";
import {
  FlightDatum,
  FlightDuur,
  FlightKist,
  FlightMethode,
  FlightRol,
  FlightTagsColumn,
} from "~/components/flight/FlightColumns.jsx";
import { FlightViewModal } from "../../flight/FlightViewModal.jsx";
import "./overviewFlights.css";

export const LastFlightsTable = ({
  flights,
  updateFlight,
  pilot,
  loading = false,
  hidePaginate = false,
  totalCount = 0,
  currentPage = 1,
  setPage = () => {},
}) => {
  const [flight, openFlight] = useState(null);

  const onUpdateFlight = ({ flight }) => {
    openFlight(flight);
    updateFlight({ flight });
  };

  return (
    <div className="overviewFlightTab">
      <FlightViewModal
        onClose={() => openFlight(null)}
        flight_object={flight}
        currentUser={pilot}
        onUpdateFlight={onUpdateFlight}
      />

      <Table
        style={{
          overflowX: "auto",
          cursor: "pointer",
        }}
        pagination={
          !hidePaginate &&
          totalCount > 0 && {
            position: ["bottomLeft"],
            pageSize: 50,
            total: totalCount,
            current: currentPage,
            onChange: setPage,
            hideOnSinglePage: false,
            showSizeChanger: false,
          }
        }
        size="small"
        rowKey="uuid"
        dataSource={flights}
        columns={[
          FlightDatum(),
          FlightKist(),
          FlightRol(pilot),
          FlightMethode(),
          FlightDuur(),
          FlightTagsColumn(pilot),
        ]}
        loading={loading}
        onRow={(flight) => {
          return {
            onClick: () => {
              openFlight(flight);
            },
          };
        }}
      />
    </div>
  );
};
